<template>
    <div class="indicator-style2">
        <style-icon v-if="chartData.styleConfig.commongConfig.indicatorIcon" :chartData="chartData" :rowValue="info.rowValue" :idx="idx" />
        <div class="indicator-style-item-content">
            <div class="indicator-style-item bi_dashboard_text_overflow" style="margin-bottom: 4px;line-height: 1.5;font-weight: 700;" :title="info.rowValue">{{ info.rowValue }}
            </div>
            <div class="list-content">
                <div class="bi_dashboard_text_overflow" :title="info.measureName">{{ info.measureName }}</div>
                <div class="bi_dashboard_text_overflow" :title="transferWhiteVal(info.measureValue)" style="font-size: 28px;font-weight: 700;">{{ transferWhiteVal(info.measureValue) }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import { transferWhiteVal } from '../../../utils'
import styleIcon from './styleIcon.vue'
export default {
    name: 'style2',
    components: {
        styleIcon,
    },
    props: {
        info: {
            type: Object,
            default: () => { },
        },
        chartData: {
            type: Object,
            default: () => { },
        },
        idx: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            transferWhiteVal,
        }
    },
}
</script>

<style scoped lang="less">
.indicator-style2 {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    .indicator-style-item-content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-left: 12px;
    }
}
</style>
